import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import RankingChart, { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { StartupItemTypeStatTop5 } from '../service'


export default /*#__PURE__*/_defineComponent({
  __name: 'boot-type-distribution-chart',
  props: {
    rawData: { default: undefined }
  },
  emits: ["typeClick"],
  setup(__props: any, { emit: __emit }) {

const AUTORUN_TYPE_I18N_KEY: Record<number, string> = {
  1: 'bootOptimize.bootTypeMenu',
  2: 'bootOptimize.bootTypeTask',
  3: 'bootOptimize.bootTypeRegSoft',
  4: 'bootOptimize.bootTypeRegService',
}

const props = __props

const emit = __emit

const { t, locale } = useI18n()

function onItemClick(item: RankingItem) {
  const autorun_type = Number(item.autorun_type)
  if (!Number.isFinite(autorun_type) || autorun_type < 1 || autorun_type > 4) return
  emit('typeClick', {
    autorun_type,
    name: String(item.name ?? ''),
    count: Number(item.count) || 0,
  })
}

function autorunTypeLabel(autorun_type: number) {
  const key = AUTORUN_TYPE_I18N_KEY[autorun_type]
  return key ? t(key) : t('bootOptimize.unknownBootType')
}

const chartData = computed(() => {
  void locale.value
  const list = props.rawData || []
  return list.map((item) => ({
    name: autorunTypeLabel(item.autorun_type),
    count: item.count,
    autorun_type: item.autorun_type,
  }))
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('bootOptimize.bootTypeDistributionTitle'),
    data: chartData.value,
    "show-time-range": false,
    unit: _ctx.$t('common.unitItems'),
    "name-key": "name",
    "max-items": 5,
    "card-size": "second",
    "item-key-field": "autorun_type",
    "row-clickable": "",
    onItemClick: onItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "data", "unit"]))
}
}

})